module.exports = __webpack_public_path__ + "img/286a2ef1350b405496b35d98829dffe4.png";